import { render, staticRenderFns } from "./MultiUserPicker.vue?vue&type=template&id=4ba3bf8e"
import script from "./MultiUserPicker.vue?vue&type=script&lang=js"
export * from "./MultiUserPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ba3bf8e')) {
      api.createRecord('4ba3bf8e', component.options)
    } else {
      api.reload('4ba3bf8e', component.options)
    }
    module.hot.accept("./MultiUserPicker.vue?vue&type=template&id=4ba3bf8e", function () {
      api.rerender('4ba3bf8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/taskdetails/MultiUserPicker.vue"
export default component.exports